
import React, { useRef, useState } from 'react';
import { UploadCloud, Trash2, Play, X } from 'lucide-react';
import { getImageUrl } from '../../config';

export default function AdminGallery({ items, t, onUpload, onDelete }) {
  const [dragActive, setDragActive] = useState(false);
  const [videoModal, setVideoModal] = useState(null);
  const galleryInputRef = useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") setDragActive(true);
    else if (e.type === "dragleave") setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
        onUpload(e.dataTransfer.files[0]);
    }
  };

  return (
    <div>
        <div 
            className={`border-2 border-dashed rounded-xl p-8 text-center transition-colors cursor-pointer mb-8
              ${dragActive ? 'border-pink-500 bg-pink-50' : 'border-gray-300 hover:border-pink-400 hover:bg-gray-50'}
            `}
            onDragEnter={handleDrag}
            onDragLeave={handleDrag}
            onDragOver={handleDrag}
            onDrop={handleDrop}
            onClick={() => galleryInputRef.current.click()}
        >
             <input
               ref={galleryInputRef}
               type="file"
               className="hidden"
               accept="image/*,video/*"
               onChange={(e) => e.target.files[0] && onUpload(e.target.files[0])}
             />
             
             <div className="flex flex-col items-center justify-center space-y-2">
                <UploadCloud className={`h-12 w-12 ${dragActive ? 'text-pink-600' : 'text-gray-400'}`} />
                <p className="text-sm text-gray-600 font-medium">
                  {t.admin.gallery.add}
                </p>
                <p className="text-xs text-gray-400">{t.admin.gallery.formats}</p>
             </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {items.map((item) => (
                <div key={item.id} className="relative group rounded-lg overflow-hidden shadow-md bg-gray-100 aspect-square">
                    {item.type === 'video' ? (
                        <div 
                            className="w-full h-full relative cursor-pointer"
                            onClick={() => setVideoModal(item.url)}
                        >
                            <video 
                              src={getImageUrl(item.url)} 
                              className="w-full h-full object-cover pointer-events-none"
                              preload="metadata"
                            />
                            <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                                <div className="bg-white/90 rounded-full p-4 group-hover:scale-110 transition-transform shadow-lg">
                                    <Play className="h-8 w-8 text-pink-600 fill-current" />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <img src={getImageUrl(item.url)} alt="Gallery" className="w-full h-full object-cover" />
                    )}
                    
                    <button 
                        onClick={(e) => {
                            e.stopPropagation();
                            onDelete(item.id);
                        }}
                        className="absolute top-2 right-2 bg-red-600 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 hover:bg-red-700 shadow-md z-50 cursor-pointer transition-opacity"
                        title="Supprimer"
                    >
                        <Trash2 className="h-4 w-4" />
                    </button>
                </div>
            ))}
        </div>

        {videoModal && (
          <div 
            className="fixed inset-0 bg-black/95 z-[100] flex items-center justify-center p-4"
            onClick={() => setVideoModal(null)}
          >
            <button
              onClick={() => setVideoModal(null)}
              className="absolute top-4 right-4 text-white hover:text-pink-500 transition-colors z-[110]"
              aria-label="Fermer"
            >
              <X className="h-8 w-8" />
            </button>
            
            <div 
              className="relative max-w-6xl w-full"
              onClick={(e) => e.stopPropagation()}
            >
              <video
                src={getImageUrl(videoModal)}
                className="w-full h-auto max-h-[90vh] rounded-lg shadow-2xl"
                controls
                autoPlay
                controlsList="nodownload"
              />
            </div>
          </div>
        )}
    </div>
  );
}
